import { PoiIcon } from '@/components/Analysis/modules/pointOfInterest/PointOfInterestTab/PoiIcon';
import { poiTemplateIcons as poiTemplateIconsAtom } from '@/components/Analysis/state';
import { POI_DETAILS_DEFAULT, POI_DETAILS_FALLBACK } from '@/constants';
import { TemplateWithPOIs } from '@/types';
import { upperSnakeCase } from '@/utils';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

type Props = {
  location: TemplateWithPOIs['pointOfInterests'][0]['location'];
  scale: number;
  name: string;
  poiTemplateKey?: string | null | undefined
};

export const DeckplanOverlayPoiSvg = ({ location, scale, name, poiTemplateKey }: Props) => {
  const poiTemplateIcons = useAtomValue(poiTemplateIconsAtom);

  const { cx, cy } = location;

  const fill = useMemo(() => {
    return `#${
      poiTemplateIcons
        .find((template) => upperSnakeCase(template.name) === upperSnakeCase(name))
        ?.color?.replace('#', '') ??
      POI_DETAILS_FALLBACK.find((fallbackDetail) => fallbackDetail.name === upperSnakeCase(name))
        ?.iconColor ??
      POI_DETAILS_DEFAULT.iconColor
    }`;
  }, [name, poiTemplateIcons]);

  return (
    <>
      <circle
        cx={cx + 8.5 / scale}
        cy={cy + 8 / scale}
        r={24 / scale}
        fill={fill}
        stroke="#000"
        strokeWidth={1 / scale}
        style={{
          mixBlendMode: 'normal',
          opacity: 0.7,
        }}
      />
      <svg width={17 / scale} height={17 / scale} stroke="#fff" color="#fff" x={cx} y={cy}>
        <PoiIcon name={name} poiTemplateKey={poiTemplateKey} />
      </svg>
    </>
  );
};
